import * as React from 'react';
import { useSelector } from 'react-redux';

import { FiltersButton } from '../../../components/Navigation/buttons';
import { selectFiltersUrl } from '../../../selectors/urls';
import { trackFiltersClick } from './analytics';

export const FiltersButtonContainer: React.FC = () => {
  const url = useSelector(selectFiltersUrl);

  const handleClick = React.useCallback((event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    event.preventDefault();

    const href = event.currentTarget.href;
    trackFiltersClick();

    setTimeout(() => {
      document.cookie = 'flavour=mobile;domain=.cian.ru;path=/';
      window.location.href = href;
    }, 300);
  }, []);

  return <FiltersButton url={url} onClick={handleClick} />;
};
